export async function postData (url, data) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': window.RequestVerificationHeader
    },
    credentials: 'include',
    cache: 'no-store',
    body: JSON.stringify(data)
  });
  return await response.json();
};
